import { Grid } from '@mui/material'
import { Globe, User } from 'lucide-react'
import React from 'react'

const CompanyDetailsTab = ({user}) => {
  return (
    <div className="space-y-6">
              {user.role === "professional" ? (
                <div className="text-center py-8 text-secondary-500">
                  <User className="w-12 h-12 mx-auto mb-4 text-gray-400" />
                  <p>
                    This user is a professional and doesn't have company details
                  </p>
                </div>
              ) : (
                <Grid container spacing={4}>
                  <Grid size={{ xs: 12, md: 6 }}>
                    <h3 className="text-lg font-semibold mb-4 text-secondary-900">
                      Company Information
                    </h3>
                    <div className="space-y-4">
                      <div className="flex justify-between py-2 border-b">
                        <span className="text-secondary-600">Company Name</span>
                        <span className="font-medium">
                          {user.company_name || "Not provided"}
                        </span>
                      </div>
                      <div className="flex justify-between py-2 border-b">
                        <span className="text-secondary-600">Company Type</span>
                        <span className="font-medium capitalize">
                          {user.company_type === 'other' && user.other_company_type
                            ? `Other (${user.other_company_type})`
                            : user.company_type || "Not specified"}
                        </span>
                      </div>
                      <div className="flex justify-between py-2 border-b">
                        <span className="text-secondary-600">
                          Registration Number
                        </span>
                        <span className="font-medium">
                          {user.company_registration_number || "Not provided"}
                        </span>
                      </div>
                      <div className="flex justify-between py-2 border-b">
                        <span className="text-secondary-600">
                          Company Email
                        </span>
                        <span className="font-medium">
                          {user.company_email || "Not provided"}
                        </span>
                      </div>
                    </div>
                  </Grid>

                  <Grid size={{ xs: 12, md: 6 }}>
                    <h3 className="text-lg font-semibold mb-4 text-secondary-900">
                      Contact & Location
                    </h3>
                    <div className="space-y-4">
                      <div className="flex justify-between py-2 border-b">
                        <span className="text-secondary-600">
                          Company Phone
                        </span>
                        <span className="font-medium">
                          {user.company_phone || "Not provided"}
                        </span>
                      </div>
                      <div className="flex justify-between py-2 border-b">
                        <span className="text-secondary-600">
                          Company Website
                        </span>
                        <span className="font-medium">
                          {user.company_website ? (
                            <a
                              href={user.company_website}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="text-blue-600 hover:underline flex items-center"
                            >
                              <Globe className="w-4 h-4 mr-1" />
                              Visit Website
                            </a>
                          ) : (
                            "Not provided"
                          )}
                        </span>
                      </div>
                      <div className="flex justify-between py-2 border-b">
                        <span className="text-secondary-600">
                          Company Address
                        </span>
                        <span className="font-medium text-right">
                          {user.company_address || "Not provided"}
                        </span>
                      </div>
                    </div>
                  </Grid>
                </Grid>
              )}
            </div>
  )
}

export default CompanyDetailsTab